// AIDEV-NOTE: Loader dinamico para modulos Capacitor.
//             Usa eval('import(...)') para evitar que Rollup/Vite tentem resolver os modulos
//             em build time. Estes modulos so existem quando o app roda dentro de Capacitor (nativo).

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyModule = any;

// AIDEV-NOTE: Variavel com nome do modulo construida em runtime para evitar analise estatica do bundler
function dynamicImport(moduleName: string): Promise<AnyModule> {
  return new Function('m', 'return import(m)')(moduleName) as Promise<AnyModule>;
}

export async function loadCapacitorCamera(): Promise<AnyModule> {
  return dynamicImport('@capacitor/camera');
}

export async function loadCapacitorPushNotifications(): Promise<AnyModule> {
  return dynamicImport('@capacitor/push-notifications');
}

export async function loadCapacitorApp(): Promise<AnyModule> {
  return dynamicImport('@capacitor/app');
}
